const ROOT_SELECTOR = '[data-dm-bundle-root]';
const instances = new Map();
const toNumber = (value, fallback = 0) => {
const n = Number(value);
return Number.isFinite(n) ? n : fallback;
};
function enqueueCartMutation(task) {
const cartWindow =  (window);
const previous = cartWindow.__daymeritCartMutationQueue || Promise.resolve();
const current = previous.catch(() => undefined).then(task);
cartWindow.__daymeritCartMutationQueue = current.catch(() => undefined);
return current;
}
const moneyFormatter = (currency) => {
try {
return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
style: 'currency',
currency: currency || 'USD',
minimumFractionDigits: 2,
maximumFractionDigits: 2,
});
} catch (_) {
return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
}
};
const getCart = async () => {
const cartUrl = Theme.routes.cart_url.replace(/\/$/, '');
const response = await fetch(`${cartUrl}.js`, {
headers: { Accept: 'application/json' },
credentials: 'same-origin',
cache: 'no-store',
});
if (!response.ok) throw new Error('Unable to check your cart. Please try again.');
return response.json();
};
const planBundleSync = (cart, desiredLines, productId) => {
const ownItems = cart.items.filter((item) => String(item.product_id) === String(productId));
const desired = new Map(desiredLines.map(({ variantId, quantity }) => [String(variantId), quantity]));
const current = new Map();
for (const item of ownItems) {
const id = String(item.variant_id);
current.set(id, (current.get(id) || 0) + Number(item.quantity));
}
const matches = current.size === desired.size
&& [...desired].every(([id, quantity]) => current.get(id) === quantity);
if (matches) return { matches, ownItems, updates: {} };
const updates = {};
const assigned = new Set();
for (const item of ownItems) {
if (!item.key) throw new Error('Unable to identify an existing bracelet in your cart.');
const id = String(item.variant_id);
if (desired.has(id) && !assigned.has(id)) {
updates[String(item.key)] = desired.get(id);
assigned.add(id);
} else {
updates[String(item.key)] = 0;
}
}
for (const [id, quantity] of desired) {
if (!assigned.has(id)) updates[id] = quantity;
}
return { matches: false, ownItems, updates };
};
const DM_GIFT_ID = 67576467685685;
const syncCheckoutCart = async (lines, paidGiftBox, allBraceletVariantIds) => {
const braceletQuantity = lines.reduce((n,line)=>n+Number(line.quantity),0);
if (!braceletQuantity || lines.some(line=>!Number.isInteger(Number(line.quantity)) || Number(line.quantity)<1)) {
throw new Error('Choose your bracelets before checkout.');
}
const giftBoxVariantId = Number(paidGiftBox?.variantId || 0);
const giftBoxQuantity = paidGiftBox?.selected && giftBoxVariantId
  ? Math.max(1, Math.min(10, Math.round(toNumber(paidGiftBox.quantity, 1))))
  : 0;

// One Cart API request sets the complete DAYMERIT purchase state.
// cart/update.js also adds variants that aren't already in the cart.
const desiredBracelets = new Map(lines.map((line)=>[String(line.variantId),Number(line.quantity)]));
const updates={};
for(const id of allBraceletVariantIds){
updates[String(id)]=desiredBracelets.get(String(id)) || 0;
}
updates[String(DM_GIFT_ID)]=braceletQuantity;
if(giftBoxVariantId) updates[String(giftBoxVariantId)]=giftBoxQuantity;

const base=Theme.routes.cart_url.replace(/\/$/,'');
const response=await fetch(base+'/update.js',{
method:'POST',
headers:{'Content-Type':'application/json',Accept:'application/json'},
credentials:'same-origin',
body:JSON.stringify({updates}),
});
if(!response.ok){
let message='Unable to update your order.';
try{
const result=await response.json();
message=result.description||result.message||message;
}catch(_){}
throw new Error(message);
}
};
const init = (root) => {
if (!(root instanceof HTMLElement) || root.dataset.dmBundleReady === 'true') return;
instances.get(root.id)?.();
const controller = new AbortController();
const { signal } = controller;
root.dataset.dmBundleReady = 'true';
const section = root.closest('.shopify-section') || document;
const offers = Array.from(root.querySelectorAll('[data-dm-offer]'));
const currency = root.dataset.currency || 'USD';
const formatter = moneyFormatter(currency);
const blockId = root.dataset.blockId || '';
const stickySelector = `[data-dm-sticky-for="${CSS.escape(blockId)}"]`;
let sticky = section.querySelector?.(stickySelector) || document.querySelector(stickySelector);
if (sticky instanceof HTMLElement) {
document.body.querySelectorAll(stickySelector).forEach((candidate) => {
if (candidate !== sticky) candidate.remove();
});
if (sticky.parentElement !== document.body) document.body.appendChild(sticky);
}
const stickyButton = sticky?.querySelector('[data-dm-sticky-button]');
let selectedQuantity = Math.max(1, toNumber(root.dataset.selectedQuantity, 1));
let adding = false;
let redirecting = false;
const summary = root.querySelector('[data-dm-order-summary]');
const errorMessage = root.querySelector('[data-dm-bundle-error]');
const productForm = section.querySelector('product-form-component');
const addButton = productForm?.querySelector('[ref="addToCartButton"]');
const nativeForm = productForm?.querySelector('form');
let buttonLabel;
if (addButton instanceof HTMLButtonElement) {
addButton.dataset.dmMainAdd = '';
Array.from(addButton.childNodes).forEach((node) => {
if (node.nodeType === Node.TEXT_NODE) node.remove();
});
buttonLabel = addButton.querySelector('[data-dm-add-label]');
if (!buttonLabel) {
buttonLabel = document.createElement('span');
buttonLabel.dataset.dmAddLabel = '';
addButton.appendChild(buttonLabel);
}
if (summary) productForm.before(summary);
}
const showGalleryMedia = (mediaId) => {
if (!mediaId) return;
const galleryRoot = section.querySelector('[data-dm-product-gallery]');
if (!(galleryRoot instanceof HTMLElement)) return;
const thumb = Array.from(galleryRoot.querySelectorAll('[data-dm-gallery-thumb]')).find(
(candidate) => candidate instanceof HTMLElement && candidate.dataset.dmMediaId === String(mediaId)
);
if (thumb instanceof HTMLButtonElement) thumb.click();
};
const updateSelection = () => {
const offer = selectedOffer();
if (!offer) return;
const selects = Array.from(offer.querySelectorAll('[data-dm-variant-select]'));
if (summary) summary.textContent = 'Free shipping on all orders';
const ctaLabel = 'Get Mine Today';
if (buttonLabel) buttonLabel.textContent = adding ? 'Taking you to checkout…' : ctaLabel;
if (addButton instanceof HTMLButtonElement) {
addButton.disabled = adding || selects.length !== selectedQuantity || selects.some((select) => !select.value);
addButton.setAttribute('aria-label', adding ? 'Taking you to checkout' : ctaLabel);
addButton.setAttribute('aria-busy', String(adding));
}
for (const row of root.querySelectorAll('[data-dm-color-row]')) {
const value = row.querySelector('[data-dm-variant-select]')?.value;
row.querySelectorAll('[data-dm-variant-choice]').forEach((button) => {
const checked = button.dataset.dmVariantChoice === value;
button.setAttribute('aria-checked', String(checked));
button.tabIndex = checked ? 0 : -1;
});
}
const pairOffer = offers.find((candidate) => candidate.dataset.quantity === '2');
const pairIds = Array.from(pairOffer?.querySelectorAll('[data-dm-variant-select]') || [], (select) => select.value).join(',');
pairOffer?.querySelectorAll('[data-dm-pair]').forEach((button) => {
const checked = button.dataset.dmPair === pairIds;
button.setAttribute('aria-checked', String(checked));
button.tabIndex = checked ? 0 : -1;
});
};
const selectedOffer = () =>
offers.find((offer) => toNumber(offer.dataset.quantity) === selectedQuantity) || offers[0];
const selectOffer = (offer) => {
if (!(offer instanceof HTMLElement)) return;
selectedQuantity = Math.max(1, toNumber(offer.dataset.quantity, 1));
root.dataset.selectedQuantity = String(selectedQuantity);
for (const candidate of offers) {
const selected = candidate === offer;
candidate.classList.toggle('is-selected', selected);
const activator = candidate.querySelector('[data-dm-offer-activate]');
activator?.setAttribute('aria-checked', String(selected));
if (activator) activator.tabIndex = selected ? 0 : -1;
const config = candidate.querySelector('[data-dm-config]');
if (config instanceof HTMLElement) config.hidden = !selected;
}
updateSelection();
};
const wireRadioGroup = (buttons, activate) => {
buttons.forEach((button, index) => {
button.addEventListener('click', () => activate(button), { signal });
button.addEventListener('keydown', (event) => {
const offsets = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
if (!(event.key in offsets) && event.key !== 'Home' && event.key !== 'End') return;
event.preventDefault();
event.stopPropagation();
let next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + offsets[event.key] + buttons.length) % buttons.length;
const target = buttons[next];
if (!target || target.disabled) return;
activate(target);
target.focus();
}, { signal });
});
};
wireRadioGroup(offers.map((offer) => offer.querySelector('[data-dm-offer-activate]')).filter(Boolean), (button) => selectOffer(button.closest('[data-dm-offer]')));
root.querySelectorAll('[data-dm-color-row]').forEach((row) => {
const select = row.querySelector('[data-dm-variant-select]');
if (!(select instanceof HTMLSelectElement)) return;
select.addEventListener('change', () => {
showGalleryMedia(select.selectedOptions?.[0]?.dataset.dmMediaId);
updateSelection();
}, { signal });
wireRadioGroup(Array.from(row.querySelectorAll('[data-dm-variant-choice]')), (button) => {
select.value = button.dataset.dmVariantChoice;
showGalleryMedia(button.dataset.dmMediaId);
updateSelection();
});
});

wireRadioGroup(Array.from(root.querySelectorAll('[data-dm-pair]')), (button) => {
const values = button.dataset.dmPair.split(',');
button.closest('[data-dm-offer]').querySelectorAll('[data-dm-variant-select]').forEach((select, index) => {
select.value = values[index] || '';
});
showGalleryMedia(button.dataset.dmMediaId);
updateSelection();
});
const giftBoxes = Array.from(root.querySelectorAll('[data-dm-giftbox]'));
for (const box of giftBoxes) {
const checkbox=box.querySelector('[data-dm-giftbox-checkbox]');
const qtyInput=box.querySelector('[data-dm-giftbox-quantity]');
const qtyControls=box.querySelector('[data-dm-giftbox-qty-controls]');
const defaultQty=Math.max(1,toNumber(box.dataset.defaultQuantity,1));
if(qtyInput instanceof HTMLInputElement) qtyInput.value=String(defaultQty);
if(checkbox instanceof HTMLInputElement) checkbox.checked=false;
const refresh=()=>{
const checked=checkbox instanceof HTMLInputElement && checkbox.checked;
box.classList.toggle('is-selected',checked);
if(qtyControls instanceof HTMLElement) qtyControls.hidden=!checked;
};
checkbox?.addEventListener('change',refresh,{signal});
box.querySelector('[data-dm-giftbox-minus]')?.addEventListener('click',()=>{
if(!(qtyInput instanceof HTMLInputElement))return;
const min=Math.max(1,toNumber(qtyInput.min,1));
qtyInput.value=String(Math.max(min,toNumber(qtyInput.value,defaultQty)-1));
},{signal});
box.querySelector('[data-dm-giftbox-plus]')?.addEventListener('click',()=>{
if(!(qtyInput instanceof HTMLInputElement))return;
const max=Math.max(1,toNumber(qtyInput.max,10));
qtyInput.value=String(Math.min(max,toNumber(qtyInput.value,defaultQty)+1));
},{signal});
qtyInput?.addEventListener('change',()=>{
if(!(qtyInput instanceof HTMLInputElement))return;
const min=Math.max(1,toNumber(qtyInput.min,1));
const max=Math.max(min,toNumber(qtyInput.max,10));
qtyInput.value=String(Math.max(min,Math.min(max,Math.round(toNumber(qtyInput.value,defaultQty)))));
},{signal});
refresh();
}
const getGiftBoxSelection=()=>{
const offer=selectedOffer();
const box=offer?.querySelector('[data-dm-giftbox]');
if(!(box instanceof HTMLElement))return null;
const checkbox=box.querySelector('[data-dm-giftbox-checkbox]');
const qtyInput=box.querySelector('[data-dm-giftbox-quantity]');
return {
variantId:box.dataset.variantId||'',
selected:checkbox instanceof HTMLInputElement&&checkbox.checked,
quantity:Math.max(1,Math.round(toNumber(qtyInput?.value,toNumber(box.dataset.defaultQuantity,1)))),
};
};
const getBundleLines = () => {
const offer = selectedOffer();
if (!offer) return [];
const selects = Array.from(offer.querySelectorAll('[data-dm-variant-select]')).slice(0, selectedQuantity);
const counts = new Map();
for (const select of selects) {
if (!(select instanceof HTMLSelectElement) || !select.value) continue;
counts.set(select.value, (counts.get(select.value) || 0) + 1);
}
return Array.from(counts.entries()).map(([variantId, quantity]) => ({
variantId: String(variantId),
quantity,
}));
};
const batchAdd = async () => {
if (adding) return;
const lines = getBundleLines();
const totalQuantity = lines.reduce((sum, line) => sum + line.quantity, 0);
if (!lines.length || totalQuantity !== selectedQuantity) return;
adding = true;
if (errorMessage) errorMessage.hidden = true;
updateSelection();
try {
const allBraceletVariantIds = Array.from(
  new Set(Array.from(root.querySelectorAll('[data-dm-variant-select] option'), (option) => option.value).filter(Boolean))
);
await syncCheckoutCart(lines, getGiftBoxSelection(), allBraceletVariantIds);
redirecting = true;
window.location.assign('/checkout');
} catch (error) {
redirecting = false;
if (errorMessage) {
errorMessage.textContent = error?.message || 'Unable to update your set. Please try again.';
errorMessage.hidden = false;
}
console.error('[DAYMERIT bundle]', error);
} finally {
if (!redirecting) {
adding = false;
updateSelection();
}
}
};
const handleAdd = (event) => {
event.preventDefault();
event.stopImmediatePropagation();
batchAdd();
};
addButton?.addEventListener('click', handleAdd, { capture: true, signal });
nativeForm?.addEventListener('submit', handleAdd, { capture: true, signal });
const updateSticky = () => {
if (!(sticky instanceof HTMLElement)) return;
if (!root.isConnected) {
sticky.dataset.dmVisible = 'false';
sticky.setAttribute('aria-hidden', 'true');
return;
}
const shouldShow = root.getBoundingClientRect().bottom < 12;
sticky.dataset.dmVisible = shouldShow ? 'true' : 'false';
sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
};
stickyButton?.addEventListener('click', () => {
root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
}, { signal });
window.addEventListener('pageshow', (event) => {
if (event.persisted) {
redirecting = false;
adding = false;
updateSelection();
}
}, { signal });
window.addEventListener('scroll', updateSticky, { passive: true, signal });
window.addEventListener('resize', updateSticky, { passive: true, signal });
window.visualViewport?.addEventListener('resize', updateSticky, { passive: true, signal });
const destroy = () => {
controller.abort();
sticky?.remove();
summary?.remove();
root.removeAttribute('data-dm-bundle-ready');
if (instances.get(root.id) === destroy) instances.delete(root.id);
};
instances.set(root.id, destroy);
document.addEventListener('shopify:section:unload', (event) => {
if (event.target instanceof Element && event.target.contains(root)) destroy();
}, { signal });
for (const offer of offers) {
const qty = Math.max(1, toNumber(offer.dataset.quantity, 1));
const totalCents = Math.max(0, toNumber(offer.dataset.totalCents, 0));
const per = offer.querySelector('[data-dm-per-price]');
if (per && totalCents) {
per.textContent = `${formatter.format(totalCents / qty / 100)} each`;
}
}
selectOffer(selectedOffer());
requestAnimationFrame(updateSticky);
};
const initAll = (scope = document) => {
if (scope instanceof HTMLElement && scope.matches(ROOT_SELECTOR)) init(scope);
scope.querySelectorAll?.(ROOT_SELECTOR).forEach(init);
};
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', () => initAll());
} else {
initAll();
}
document.addEventListener('shopify:section:load', (event) => initAll(event.target));
